import { SPACE } from "../utils/frfr-string-consts";
import { _virbom_manipulator } from "../utils/frfr-virbom-manipulator-utils";
import { virbomCounter } from "../utils/frfr-virbom-counter-utils";
import { draftel_codecs_pack_terkk$_bundle_usmerivacvazduha } from "./ter-draftel-codec-lib-terkk-bundle-usmerivacvazduha";
import { terUtilsNumberRoundUp } from "./ter-utils";
import { _getParamsFromLib } from "./ter-params-utils";
import { SINGLE_PIECE_PER_NEXT_OPERATION_UNIT } from "./virtel-consts";
import tclocal from "./ter-consts-local-lib";
import { _getFromLibMaterijalLimSingleParam, _getParamsFromLibMaterijalLimParams } from "./ter-materijal-utils";
import { AND, PI, ROUND, SIN, XIF } from "../utils/excel-functions-utils";
import { terProtobompUtils_make_protobomp_manifest_terkk_latest, terProtobompUtils_pbnode_entity_create_ASSEMBLY_TER_SKLOP } from "./ter-protobomp-utils";
import { protobomp_manipulator } from "../utils/frfr-protobomp-utils";


export const derDraftel_terkk_usmerivacvazduha_pripremi_pods_input_inherited_za_draftel = (virtel_m) => {
  // returnujemo jednostavan objekat sa svim ulaznim velicinama za derivat formulu
  const pods_input_inherited = {
    ...draftel_codecs_pack_terkk$_bundle_usmerivacvazduha.default_pods_input_state(),
    // TODO
    /*
    msirinaspoljasnja: virtel_m.msirinaspoljasnja,
    duzinamodula: virtel_m.duzinamodula,
    // brojmodula: virtel_m.brojmodula, // ???
    siframodula: virtel_m.siframodula,
    */
  };
  return pods_input_inherited;
};


//
export const _derivat_terkk_usmerivacvazduha_izracunaj_naziv = (sirina, duzina, tip, krovniotvor, a, b) => {
  let naziv = '?';
  // TODO

  return naziv;
};


//
export const _derivat_terkk_usmerivacvazduha_pbnode_dirty_enrich = (pbnode_state_ref, protobomp_superdata, is_init) => {
  // DIRTY ENRICH
  // TODO ...props super superProps
  // console.log('item_ref, protobomp_superdata', item_ref, protobomp_superdata);
  const item = pbnode_state_ref;
  const family = item.pbnode_family;
  let povrsina = -1;
  let _cnc = null;
  let _naziv = null;
  let _materijal = '?'; // item.identmaterijala
  let _naziv_profil_komore_50_ili_70 = '?';
  let _naziv_tip_kadice = '?';
  let _tip_klizaca_abc = '?';
  let _tip_kadice = '?';
  let _strana_maske = '?';
  let _sufix = '?';
  let _visina_20_ili_35 = -1;
  /*
  Gde su: 

  */
  //
  const _mat_params = _getParamsFromLibMaterijalLimParams(item.identmaterijala);
  if (is_init === true) {
    if (typeof _mat_params.naziv === 'string') {
      item.naziv_materijala = _mat_params.naziv; // DIRTY
    } else {
      item.naziv_materijala = ''; // DIRTY
    }
  }
  const _tipmetalalima = _mat_params?.naziv_materijala;
  if (_tipmetalalima === "Prohrom") {
    _materijal = "SS";
  }
  if (_tipmetalalima === "Pocinkovani") {
    _materijal = "GS";
  }
  //
  const {

  } = protobomp_superdata;
  //

  //
  if (true) {
    // sklop
    if (family === 'terkk$pkz/SKLOP_KULISA') {
      item.naziv = "???"; // DIRTY
    }
    // sklop
    if (family === 'terkk$pkz/SKLOP_NOSAC') {
      item.naziv = "???"; // DIRTY
    }
    //
    //
  }
  // 
  if (povrsina > -1) {
    item.povrsina = terUtilsNumberRoundUp((povrsina / 1000000), 2); // konvertovana u m2 i zaokruzeno na 2 decimale // DIRTY
  }
  if (_cnc) {
    item.cnccrtez = _cnc; // DIRTY
  }
  if (_naziv) {
    item.naziv = _naziv; // DIRTY
  }
  //
  return item;
};


//
export const _derivat_terkk_usmerivacvazduha_izracunaj_za_step_protobomp = (state, pods_input) => {
  //
  const {

  } = pods_input;
  const {

  } = state;

  // TODO
  const protobomp_superdata = {

  };

  //
  // _subform_arr
  let _arr = [];
  let _protobomp = protobomp_manipulator.init(terProtobompUtils_make_protobomp_manifest_terkk_latest("terkk$usmerivacvazduha"), protobomp_superdata);
  //
  //
  const _pbnode_dirty_enrich = _derivat_terkk_usmerivacvazduha_pbnode_dirty_enrich; // TODO
  // ----- kreiranje sklopova
  //
  const _sklop_uzor = {
  };
  let _temp_sklop;
  let _temp_pbnode;
  _temp_sklop = {
    ..._sklop_uzor,
    pbnode_family: 'terkk$usmerivacvazduha/SKLOP_USMERIVAC',
    naziv: '* ?',
    kolicina: -99,
  };
  _pbnode_dirty_enrich(_temp_sklop, protobomp_superdata, true);
  _temp_pbnode = terProtobompUtils_pbnode_entity_create_ASSEMBLY_TER_SKLOP(_temp_sklop, { allow_delete: true }, 'SKLOP_NOVO');
  const { created_tempkey: sklop_novo } = protobomp_manipulator.add(_protobomp, _temp_pbnode, null);
  //
  // ----- dodavanje primitivnih u sklopove
  //

  //
  if (true) {

  }

  //
  //
  return {
    svasta: {},
    // _arr,
    _protobomp,
  }; // TODO
};


// ---------- VIRBOM DERIVATS ----------

